/* Royal Hair – article master: reading progress, table of contents from H2s, before/after slider. */
(function () {
  /* 2026-10-22: run once per page. The file is included by several sections and the Theme Editor re-executes it on every section reload; listeners/observers must not accumulate. */
  if (window.__rhArticleJs) return; window.__rhArticleJs = true;
  function slug(t, used) {
    var s = (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'del';
    var base = s, n = 2;
    while (used[s]) s = base + '-' + n++;
    used[s] = true;
    return s;
  }
  function init(root) {
    if (!root || root.dataset.rhaReady) return;
    root.dataset.rhaReady = '1';

    // Table of contents
    var toc = root.querySelector('[data-rha-toc]');
    var heads = [].slice.call(root.querySelectorAll('[data-rha-prose] h2'));
    var used = {};
    heads.forEach(function (h) { if (!h.id) h.id = slug(h.textContent.trim(), used); else used[h.id] = true; });
    if (toc && heads.length >= 2) {
      var list = toc.querySelector('[data-rha-toc-list]');
      heads.forEach(function (h) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        var links = [].slice.call(list.querySelectorAll('a'));
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach(function (h) { io.observe(h); });
      }
    }

    // Reading progress
    var bar = root.querySelector('[data-rha-progress]');
    if (bar) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var r = root.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }

    // Before / after
    root.querySelectorAll('[data-rha-ba]').forEach(function (ba) {
      var stage = ba.querySelector('.rha-ba__stage');
      var range = ba.querySelector('[data-rha-ba-range]');
      if (!stage || !range) return;
      var set = function () { stage.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }
  function start() { document.querySelectorAll('[data-rha]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-rha]'); if (r) init(r); });
})();
